(() => {
  const selector = '[data-pocket-main-video]';
  const init = video => {
    if (video.dataset.pocketMainInitialized) return;
    video.dataset.pocketMainInitialized = 'true';
    const source = video.querySelector('source[data-src]');
    if (!source) return;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const listeners = new AbortController();
    const on = (target, type, handler, options = {}) => target.addEventListener(type, handler, {...options, signal: listeners.signal});
    video.muted = true;
    let loaded = false, visible = false, manuallyPaused = false, manualReducedPlay = false, pageActive = true, automaticPauses = 0;
    const load = () => {
      if (loaded) return;
      loaded = true;
      source.src = source.dataset.src;
      video.preload = 'metadata';
      video.load();
    };
    const sync = () => {
      const canPlay = visible && pageActive && document.visibilityState !== 'hidden' && (!reduced.matches || manualReducedPlay) && !manuallyPaused;
      if (canPlay) {
        load();
        const pending = video.play();
        if (pending && typeof pending.catch === 'function') pending.catch(() => {});
      } else if (!video.paused) { automaticPauses += 1; video.pause(); }
    };
    // A native-control pause persists when the viewport changes; deliberate
    // control playback remains available when reduced motion is enabled.
    on(video, 'pause', () => {
      // Native media events are queued: an automatic pause may be delivered
      // after the video has already reentered the viewport.
      if (automaticPauses) { automaticPauses -= 1; return; }
      if (!video.ended) manuallyPaused = true;
    });
    on(video, 'play', () => { manuallyPaused = false; if (reduced.matches) manualReducedPlay = true; });
    on(video, 'pointerdown', load, {passive:true});
    on(video, 'keydown', load);
    let nearObserver, visibleObserver;
    if ('IntersectionObserver' in window) {
      nearObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { load(); nearObserver.disconnect(); }
      }, {rootMargin:'200px 0px', threshold:0});
      visibleObserver = new IntersectionObserver(entries => {
        const entry = entries[entries.length - 1];
        visible = entry.isIntersecting && entry.intersectionRatio >= .25;
        sync();
      }, {threshold:[0,.25]});
      nearObserver.observe(video);
      visibleObserver.observe(video);
    }
    on(reduced, 'change', () => { if (reduced.matches) manualReducedPlay = false; sync(); });
    on(document, 'visibilitychange', sync);
    on(window, 'pagehide', () => { pageActive = false; sync(); });
    on(window, 'pageshow', () => { pageActive = true; sync(); });
    on(document, 'shopify:section:unload', event => {
      if (!event.target.contains(video)) return;
      pageActive = false;
      sync();
      nearObserver?.disconnect();
      visibleObserver?.disconnect();
      listeners.abort();
    });
  };
  const scan = root => root.querySelectorAll(selector).forEach(init);
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
